import {
  IFilterDictionary,
  ILegend,
  IProjectAddress,
  ISelectedFilters,
  IUserData,
} from 'lib/models/siteMap.interface';

import { createSlice, SerializedError } from '@reduxjs/toolkit';

export interface ISiteMapState {
  projectAddress?: IProjectAddress;
  showFilterPopup: boolean;
  showDetails: boolean;
  showDimensions: boolean;
  showTerrain: boolean;
  legends: ILegend;
  selectedLotId?: string;
  // selectedBuildingId: string;  // TODO: come back when working on Stacked buildings
  // currSelectedLevel?: number;  // TODO: come back when working on Stacked buildings
  currPlanCode?: string;
  print: boolean;
  filterDictionary?: IFilterDictionary;
  selectedFilters: ISelectedFilters;
  totalSelectedFilters: number;
  filteredLots: string[];
  error?: SerializedError | string;
  isolatePlan: boolean;
  userData?: IUserData;
  currUTourUrl?: string;
}

const initialState: ISiteMapState = {
  showFilterPopup: false,
  showDetails: false,
  showDimensions: false,
  showTerrain: false,
  legends: {},
  print: false,
  selectedFilters: {},
  totalSelectedFilters: 0,
  filteredLots: [],
  isolatePlan: false,
  // currSelectedLevel: 0,  // TODO: come back when working on Stacked buildings
  // selectedBuildingId: '0',  // TODO: come back when working on Stacked buildings
};

const siteMapSlice = createSlice({
  name: 'siteMap',
  initialState,
  reducers: {
    setShowFilterPopup: (state, { payload }: { payload: boolean }) => {
      state.showFilterPopup = payload;
    },
    setShowDetails: (state, { payload }: { payload: boolean }) => {
      state.showDetails = payload;
    },
    setShowDimensions: (state, { payload }: { payload: boolean }) => {
      state.showDimensions = payload;
    },
    setShowTerrain: (state, { payload }: { payload: boolean }) => {
      state.showTerrain = payload;
    },
    setLegends: (state, { payload }: { payload: ILegend }) => {
      state.legends = payload;
    },
    setSelectedLotId: (state, { payload }: { payload: string }) => {
      state.selectedLotId = payload;
    },
    // setSelectedBuildingId: (state, { payload }) => {
    //   state.selectedBuildingId = payload;
    // },
    // setCurrSelectedLevel: (state, { payload }) => {
    //   state.currSelectedLevel = payload;
    // },
    setCurrPlanCode: (state, { payload }: { payload: string }) => {
      state.currPlanCode = payload;
    },
    setPrint: (state, { payload }: { payload: boolean }) => {
      state.print = payload;
    },
    setIsolatePlan: (state, { payload }: { payload: boolean }) => {
      state.isolatePlan = payload;
    },
    setFilterDictionary: (state, { payload }: { payload: IFilterDictionary }) => {
      state.filterDictionary = payload;
    },
    setSelectedFilters: (state, { payload }: { payload: ISelectedFilters }) => {
      state.selectedFilters = payload;
    },
    setTotalSelectedFilters: (state, { payload }: { payload: number }) => {
      state.totalSelectedFilters = payload;
    },
    setFilteredLots: (state, { payload }: { payload: string[] }) => {
      state.filteredLots = payload;
    },
    resetFilters: (state) => {
      state.totalSelectedFilters = 0;
      state.filteredLots = [];
      if (state.filterDictionary) {
        //initialize selected filters
        const selectedFilters: ISelectedFilters = {};
        Object.keys(state.filterDictionary).forEach(
          (filterName) => (selectedFilters[filterName] = [])
        );
        state.selectedFilters = selectedFilters;
      }
    },
    setUserData: (state, { payload }: { payload: IUserData }) => {
      state.userData = payload;
    },
    setCurrUTourUrl: (state, { payload }: { payload: string }) => {
      state.currUTourUrl = payload;
    },
  },
});

export const {
  setShowFilterPopup,
  setShowDetails,
  setShowDimensions,
  setShowTerrain,
  setLegends,
  setSelectedLotId,
  // setSelectedBuildingId,
  // setCurrSelectedLevel,
  setPrint,
  setIsolatePlan,
  setCurrPlanCode,
  setFilterDictionary,
  setSelectedFilters,
  setTotalSelectedFilters,
  setFilteredLots,
  resetFilters,
  setUserData,
  setCurrUTourUrl,
} = siteMapSlice.actions;
export default siteMapSlice.reducer;
